import { LoginResult } from '../classes/login-result';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthService extends APIService {
  constructor(private _http: HttpClient) { super(); }

  public loginUser(email: string, password: string): Observable<LoginResult> {
    return this._http.post<LoginResult>(`${this._baseUrl}/v1/auth/login`, {
      email: email,
      password: password
    });
  }

  public putPassword(authToken: string, newPassword: string): Observable<any> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${authToken}`});
    return this._http.put(`${this._baseUrl}/v1/breeder/me/password`, {password: newPassword}, {headers: headers});
  }

  public handleTokenResponse(res: LoginResult): void {
    localStorage.setItem('accessToken', res.accessToken);
    localStorage.setItem('tokenType', res.tokenType);
    localStorage.setItem('expiresOn', res.expiresOn);
  }
}
